import $ from "jquery";
import { removeSuggestionUploads } from "../components/dropzone";
import { smoothscroll } from "../utils/smoothscroll";

const $window = $(window);
const form = $(".block #frm-suggestion-form");
const messenger = $(".block .suggestion-form-msg");
const confirmModal = $(".block#suggestion-confirm-modal");
const confirmModalClose = $(".block input[name=data_fill]");
const confirmModalSubmit = $(".block input[name=really_submit]");

console.log(form);

form.on("submit", async function (e) {
  console.log("submit block");
  e.preventDefault();
  submitForm();
});

confirmModalSubmit.on("click", async function (e) {
  e.preventDefault();
  submitForm();
});

const submitForm = async () => {
  closeErrors();
  console.log("i am submitting");

  // const form = form[0];
  console.log(form);
  const formData = new FormData(form[0]);
  console.log(formData);
  console.log(formData.get("first_name"));

  if (checkRequired()) {
    if (confirmModal.data("lang") == "sk") {
      showError("Vyplnte polia označené hviezdičkou (*)");

    } else {
      showError("Fill in the fields marked with an asterisk (*)");
    }
    return;
  }

  if (checkAnonimity(formData)) {
    return;
  }

  $window.trigger("loader:show");

  const data = await send(formData);
  // console.log(data);
  validData(data);
  $window.trigger("loader:hide");
};

const send = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url +
        `/wp-json/kvop/v1/suggestion-send/?lang=${$("html").attr("lang")}`,
      {
        method: "POST",
        body: filter,
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const validData = (data) => {
  if ("status" in data && data.status) {
    showSuccess(data.message);
    clearForm();
  } else {
    showError(data.message);
  }
};

const showError = (message) => {
  messenger.removeClass("form-msg__success, form-msg__err");
  messenger.addClass("form-msg__err");
  messenger.html(message).show(300);
};

const showSuccess = (message) => {
  messenger.removeClass("form-msg__success, form-msg__err");
  messenger.addClass("form-msg__success");
  messenger.html(message).show(300);
};

const closeErrors = () => {
  messenger.removeClass("form-msg__success, form-msg__err");
  messenger.html("").show(300);

  $(".has-error").each((i, elem) => {
    $(elem).removeClass("has-error");
  }
  );
};

const clearForm = () => {
  form
    .find(
      "#frm-suggestion-form-first_name, #frm-suggestion-form-last_name, #frm-suggestion-form-phone, #frm-suggestion-form-email, #frm-suggestion-form-text, #frm-suggestion-form-chckbx_legal_entity, #frm-suggestion-form-addres, #frm-suggestion-form-city, #frm-suggestion-form-chckbx_anonymity, #frm-suggestion-form-files, #frm-suggestion-form-post_code"
    )
    .val("");

  form
    .find(
      "#frm-suggestion-form-chckbx_legal_entity, #frm-suggestion-form-chckbx_anonymity, #frm-suggestion-form-chckbx_confirm_data"
    )
    .prop("checked", false);
  form.find("#frm-suggestion-form-category").prop("selectedIndex", 0);
  removeSuggestionUploads();
};

const checkAnonimity = (form) => {
  if (confirmModal.hasClass("opened")) {
    closeConfirmModal();
    return false;
  }

  if (
    (form.get("first_name") === "" ||
      form.get("last_name") === "" ||
      form.get("addres") === "" ||
      form.get("city") === "" ||
      form.get("post_code") === "") &&
    form.get("email") === ""
  ) {
    if (confirmModal.data("lang") == "sk") {
      showError("Vyplnte prosím email alebo meno a adresu");
    } else {
      showError("Please fill in your email or name and address");
    }
    if (form.get("first_name") === "") {
      let elem = $("input[name='first_name']")
      addInputError(elem, "Ak nechcete ostať v anonymite vyplnte kontaktné údaje");
    }
    if (form.get("last_name") === "") {
      let elem = $("input[name='last_name']")
      addInputError(elem, "Ak nechcete ostať v anonymite vyplnte kontaktné údaje");
    }
    if (form.get("addres") === "") {
      let elem = $("input[name='addres']")
      addInputError(elem, "Ak nechcete ostať v anonymite vyplnte kontaktné údaje");
    }
    if (form.get("city") === "") {
      let elem = $("input[name='city']")
      addInputError(elem, "Ak nechcete ostať v anonymite vyplnte kontaktné údaje");
    }
    if (form.get("post_code") === "") {
      let elem = $("input[name='post_code']")
      addInputError(elem, "Ak nechcete ostať v anonymite vyplnte kontaktné údaje");
    }
    if (form.get("email") === "") {
      let elem = $("input[name='email']")
      addInputError(elem, "Ak chcete ostať v anonymite vyplnte iba email");
    }
    return true;
  }

  if (checkEmail()) {
    showError("Zadajte platnú emailovú adresu");
    return true;
  }

  if (
    form.get("first_name") === "" ||
    form.get("last_name") === "" ||
    form.get("addres") === "" ||
    form.get("city") === "" ||
    form.get("post_code") === "" ||
    form.get("email") === ""
  ) {
    opeConfirmModal();
    return true;
  }
};

const checkRequired = () => {
  let requiredElem = form.find("[required]")
  let hasError = false;

  requiredElem.each((i, elem) => {
    let isEmpty = false;
    if ($(elem).val() === "") {
      isEmpty = true;
    }

    if ($(elem).attr("type") == "checkbox") {
      if (!$(elem)[0].checked) {
        isEmpty = true;
      }
    }

    if (isEmpty) {
      let msg = "";
      $(elem).data("nette-rules").forEach((rule) => {
        if (rule.op === ":filled") {
          msg = rule.msg;
        }
      });

      if (msg === "") {
        if (confirmModal.data("lang") == "sk") {
          msg = "Toto pole je povinné";
        } else {
          msg = "This field is required";
        }
      }

      addInputError($(elem), msg);
      hasError = true;
    }
  });

  return hasError;
}

const addInputError = (elem, msg = "") => {
  let parent = $(elem).parent();
  if ($(elem).hasClass("select__control") || $(elem).attr("type") == "checkbox") {
    parent = parent.parent();
  }
  parent.addClass("has-error");

  let error = parent.find(".error");
  if (error.length === 0) {
    parent.append(`<div class="error">${msg}</div>`);
  } else {
    error.html(msg);
  }
}

function validovatEmail(email) {
  // Definícia regulárneho výrazu pre e-mailovú adresu
  var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Testovanie e-mailovej adresy pomocou regulárneho výrazu
  return regex.test(email);
}

const checkEmail = () => {
  console.log("checking email");
  let email = form.find("input[name='email']").val();
  let hasError = false;
  if (email === "") {
    return false;
  }

  if (!validovatEmail(email)) {
    let elem = $("input[name='email']")
    addInputError(elem, "Zadajte platnú emailovú adresu");
    hasError = true;
  }
  return hasError;
}



const opeConfirmModal = () => {
  smoothscroll(confirmModal);
  confirmModal.show();
  confirmModal.addClass("opened");
};

const closeConfirmModal = () => {
  smoothscroll($("input[name=_submit]"));
  confirmModal.hide();
  confirmModal.removeClass("opened");
};

confirmModalClose.on("click", function (e) {
  e.preventDefault();
  closeConfirmModal();
  console.log("hi");
});
